import { FC, ImgHTMLAttributes } from 'react';
import styled from 'styled-components';
import { isImageLoaded, markImageLoaded } from '../common/Media';

const Img = styled.img`
  opacity: 0;
  transition: opacity 0.3s;

  &.visible {
    opacity: 1;
  }

  /* Loaded before (e.g. preloaded with the next page): shown at once */
  &.cached {
    opacity: 1;
    transition: none;
  }
`;

/**
 * An image that fades in when it has loaded, or is shown at once if it has loaded before (see preloadImages)
 * @returns {JSX.Element} Component template
 */
const FadeImage: FC<ImgHTMLAttributes<HTMLImageElement> & { src: string }> = ({ src, className, onLoad, ...props }) => (
  <Img {...props} src={src} className={[className, isImageLoaded(src) && "cached"].filter(Boolean).join(" ") || undefined}
    onLoad={e => { markImageLoaded(src); e.currentTarget.classList.add("visible"); onLoad?.(e); }}/>
);

export default FadeImage;
